import React, {useEffect, useState} from "react";
import {DateRangeWithModal, DateRangeWithModal2, DateRangeWithModal3} from "../../component/datepicker";
import {convertDate, deConvertDate} from '../../util/convertDate';

export function VisitDateComponent({selectedHandler}) {

    const [startDate, setStartDate] = useState(new Date());

    function selectedDateHandler(date) {
        setStartDate(date);
    }

    useEffect(() => {
        selectedHandler(convertDate(startDate));
    }, [startDate])

    return (
        <DateRangeWithModal startDate={startDate} selectedDateHandler={(date) => selectedDateHandler(date)} />
    )
}

export function VisitDateComponent2({selectedHandler}) {
    const [startDate, setStartDate] = useState(new Date());

    function selectedDateHandler(date) {
        setStartDate(date);
    }

    useEffect(() => {
        selectedHandler(convertDate(startDate));
    }, [startDate])

    return (
        <DateRangeWithModal3 startDate={startDate} selectedDateHandler={(date) => selectedDateHandler(date)}/>
    )
}

export function VisitSearchDateComponent({selectedHandler, minDate}) {

    const [startDate, setStartDate] = useState(new Date());

    function selectedDateHandler(date) {
        setStartDate(date);
    }

    useEffect(() => {
        selectedHandler(convertDate(startDate));
    }, [startDate])

    return (
        <DateRangeWithModal2 startDate={startDate} minDate={deConvertDate(minDate)} selectedDateHandler={(date) => selectedDateHandler(date)} />
    )
}